/* eslint-disable */
// @ts-nocheck
const router = require("@/router")
const axios = require("axios")
const Vue = require("vue")
const { clearAuthState } = require("@/utils/auth")

const defaultBaseURL = process.env.NODE_ENV === "production" ? "" : "http://localhost:9526"
const baseURL = process.env.VUE_APP_API_BASE_URL || defaultBaseURL

const hmrequest = axios.create({
  baseURL,
  timeout: 6000000,
  withCredentials: true
})

hmrequest.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token")
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  (err) => Promise.reject(err)
)

hmrequest.interceptors.response.use(
  (res) => {
    if (res.data && (res.data.code === 0 || res.data.code === 200)) {
      return res
    }
    return Promise.reject(res.data)
  },
  async (err) => {
    if (err.response?.status === 401) {
      const confirmed = await Vue.prototype.$confirm({
        title: "登录过期",
        message: "是否重新登录"
      })
      if (confirmed) {
        clearAuthState()
        router.push("/")
      }
    }
    return Promise.reject(err)
  }
)

module.exports = hmrequest
